import { isEmpty } from "lodash";
import moment from "moment";

import { UserProfileFields } from "globalConstants";

const {
	Email,
	Alias,
	Domain,
	AgentId,
	FirstName,
	LastName,
	DateOfBirth,
	Phone,
	MobilePhone,
	Address,
	City,
	State,
	Zip,
	Country,
	FusionAuthUserId,
	IsManuallyLinkedWithFusionAuth,
	CompanyName,
	CompanyId,
	CompanyWhitelistedEmailDomains,
} = UserProfileFields;

export const mapUserProfileDataFromServer = (
	data,
): { [key: string]: string } => {
	if (isEmpty(data)) return {};
	const dateOfBirthFormated = data?.[DateOfBirth.beName]
		? moment(data[DateOfBirth.beName]).format("MM/DD/YYYY")
		: "";

	return {
		[Email.name]: data?.[Email.beName],
		[FirstName.name]: data?.[FirstName.beName],
		[LastName.name]: data?.[LastName.beName],
		[DateOfBirth.name]: dateOfBirthFormated,
		[Phone.name]: data?.[Phone.beName],
		[MobilePhone.name]: data?.[MobilePhone.beName],
		[Address.name]: data?.[Address.beName],
		[City.name]: data?.[City.beName],
		[State.name]: data?.[State.beName],
		[Zip.name]: data?.[Zip.beName],
		[Country.name]: data?.[Country.beName],

		// MerchantsPreAppUrl
		[Alias.name]: data?.[Alias.beName],
		[Domain.name]: data?.[Domain.beName],
		[AgentId.name]: data?.[AgentId.beName],
		// Reset password
		[FusionAuthUserId.name]: data?.[FusionAuthUserId.beName],
		[IsManuallyLinkedWithFusionAuth.name]:
			data?.[IsManuallyLinkedWithFusionAuth.beName],
		// For parent Parent Agent Office DDL
		[CompanyName.name]: data?.[CompanyName.beName],
		[CompanyId.name]: data?.[CompanyId.beName],

		// Domains list
		[CompanyWhitelistedEmailDomains.name]:
			data?.[CompanyWhitelistedEmailDomains.beName],
	};
};

export const mapUserProfileDataToServer = (
	formValues,
): { [key: string]: string } => {
	const data = {
		[FirstName.beName]: formValues?.[FirstName.name],
		[LastName.beName]: formValues?.[LastName.name],
		[DateOfBirth.beName]: formValues?.[DateOfBirth.name],
		[Phone.beName]: formValues?.[Phone.name],
		[Address.beName]: formValues?.[Address.name],
		[City.beName]: formValues?.[City.name],
		[State.beName]: formValues?.[State.name],
		[Zip.beName]: formValues?.[Zip.name],
		[Country.beName]: formValues?.[Country.name],
		[Alias.beName]: formValues?.[Alias.name],
	};

	return data;
};
